<template>
    <div class="spinner">
        <img class="noselect" src="@/assets/loading2.gif" alt="Carregando">
        <p id="caption_1">{{ this.caption }}</p>
    </div>
</template>
 
<script>

export default {
    name: "spinnerLoading",
    props: ["caption", 'caption2'],
    data() {
        return {
            interpolation: false
        }
    },
}
</script>

<style scoped>
.spinner {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    top: calc(50% + -45px);
    left: calc(50% + -110px);
    background-color: rgba(241, 242, 243, 0.863);
    border-radius: 30px;
    overflow: hidden !important;
}

.spinner img {
    margin: 0px;
    padding: 5px 0 5px 15px;
    width: 50px;
    overflow: hidden !important;
}

.spinner>p {
    cursor: default;
    font-size: 1.2em;
    font-weight: 500;
    margin: 0 10px 0 10px;
    padding: 0 10px 0 2px;
    transition: 1s;
}

div {
    border: none;
    box-shadow: 2px 3px 7px #666;
}
</style>